import {useState} from "react";
import "./footer.css";
//
import logo from "assets/images/others/logo_white_trans.png";
//
import insta from "assets/images/socialIcons/insta.gif";
import twitter from "assets/images/socialIcons/twitter.gif";
import fb from "assets/images/socialIcons/fb.gif";
import medium from "assets/images/socialIcons/medium.gif";
import discord from "assets/images/socialIcons/discord.gif";
import yt from "assets/images/socialIcons/yt.gif";
import tiktok from "assets/images/socialIcons/tiktok.gif";
import reddit from "assets/images/socialIcons/reddit.gif";
import opensea from "assets/images/socialIcons/opensea.gif";
import telegram from "assets/images/socialIcons/telegram.gif";
import ModalDialog from "./ModalDialog";
import CookieData from "./cookieData";
import TermsData from "./termsData";
import PrivacyData from "./privacyData.jsx";
//


const Footer = () => {
  const [termModal, setTermModal] = useState(false);
  const [cookieModal, setCookieModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);

  return (
    <footer className="footer">
      <div className="container ft-top-sec row">
        {/*  */}
        <div className="picto">
          <img src={logo} alt="WeStream" />
        </div>
        {/*  */}
        <div className="footer_right">
          <div className="social row">
            {/* ============= footer social links ========================== */}
            {/* ================= Put your new link in href=" " ===================   */}
            <div className="link">
              <a
                // here
                href="https://instagram.com/WeStreamApp"
                rel="noopener noreferrer"
                target="_blank"
                className="insta row"
              >
                <img src={insta} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                // here
                href="https://twitter.com/WeStreamApp"
                target="_blank"
                rel="noopener noreferrer"
                className="twitter row"
              >
                <img src={twitter} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                // here
                href="https://t.me/WeStream"
                target="_blank"
                rel="noopener noreferrer"
                className="tele row"
              >
                <img src={telegram} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                // here
                href="https://www.facebook.com/westreamapp"
                target="_blank"
                rel="noopener noreferrer"
                className="tele row"
              >
                <img src={fb} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                // here
                href="https://discord.gg/WeStream"
                target="_blank"
                rel="noopener noreferrer"
                className="discord row"
              >
                <img src={discord} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                href="https://tiktok.com/@WeStreamApp"
                target="_blank"
                rel="noopener noreferrer"
                className="tiktok row"
              >
                <img src={tiktok} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                // here
                href="https://opensea.io/collection/westreamers-official"
                target="_blank"
                rel="noopener noreferrer"
                className="opensea row"
              >
                <img src={opensea} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                // here
                href="https://www.reddit.com/r/WeStreamApp"
                target="_blank"
                rel="noopener noreferrer"
                className="reddit row"
              >
                <img src={reddit} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                // here
                href="https://www.youtube.com/c/westreamapp"
                target="_blank"
                rel="noopener noreferrer"
                className="youtube row"
              >
                <img src={yt} alt="" />
              </a>
            </div>
            <div className="link">
              <a
                // here
                href="https://medium.com/@WeStream"
                target="_blank"
                rel="noopener noreferrer"
                className="medium row"
              >
                <img src={medium} alt="" />
              </a>
            </div>
          </div>
          <div className="ft_links">
            <a href="javascript:void(0)" onClick={()=> setTermModal(true)}>
              Terms of Use
            </a>
            <a href="javascript:void(0)" onClick={() => setCookieModal(true)}>
              Cookie Policy
            </a>
            <a href="javascript:void(0)" onClick={() => setPrivacyModal(true)}>
              Privacy Policy
            </a>
            <ModalDialog
              open={termModal}
              handleClose={()=> setTermModal(false)}
              title="Terms of Use"
              body={<TermsData/> }
            />
            <ModalDialog
              open={cookieModal}
              handleClose={()=> setCookieModal(false)}
              title="Cookie Policy"
              body={<CookieData/>}
            />
            <ModalDialog
              open={privacyModal}
              handleClose={()=> setPrivacyModal(false)}
              title="Privacy Policy"
              body={<PrivacyData/>}
            />
          </div>
        </div>
      </div>
      {/* </div> */}

      <div className="copy_area">
        <p>
          &copy;{new Date().getFullYear()} by We
          <span className="colored">Stream</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
